<template>
  <div classs="select-address">
    <div class="has-no-order" id="task-detail-header">
      <div class="has-no-order-fl">
        <img src="../../../assets/images/icon_yd.png" /><span>{{task_id}}</span>
      </div>
      <div class="has-no-order-sl" v-if="order_state != 0 && order_state != -1">{{order_state_text}}</div>
      <div class="has-no-order-sl" v-else>暂无物流</div>
    </div>
    <div class="wrap" v-show="order_state != 0 && order_state != -1">
      <div class="mapWrap">
        <div id="mapWhole" class="select-address-map"></div>
        <div class="map-tools">
          <i class="el-icon-refresh reset-icon" @click="setFitView"></i>
          <div class="route-mark">
            <div class="actual-line-tag line-tag" :class="{ 'line-tag-disactive':!actualLineShow }" @click="handleActualLineShow">实际路线</div>
            <div class="schedule-line-tag line-tag" :class="{ 'line-tag-disactive':!planLineShow }" @click="handlePlanLineShow">规划路线</div>
          </div>
        </div>
        <logsCard
        class="logs-card"
        :task_id="task_id"
        :order_state="order_state"></logsCard>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import GMAP from './map';
import { fetchDrivingTracks, fetchRouteNodes, fetchTaskState } from '../api';
import logsCard from './logsCard.vue';

const Gmap = new GMAP();

export default {
  name: 'taskDetail',
  components: { logsCard },
  props: {
    task_id: {
      // eslint-disable-next-line
      type: String | Number,
      default: '',
    },
  },
  data() {
    return {
      inputStyle: {
        width: '200px',
      },
      detailVisible: false,
      actualLineShow: true,
      planLineShow: true,
      data: {
        track: {},
        nodes: {},
      },
      activeNodeIndex: 0,
      order_state: -1,
      order_state_text: '',
      // 地图在地图自适应基础上偏移量
      mapOffset: '',
    };
  },
  computed: {},
  methods: {
    getTaskState() {
      fetchTaskState({ task_id: this.task_id }).then((res) => {
        if (res.errno === 0) {
          this.order_state_text = res.result.order_state_text;
          this.order_state = res.result.order_state;
        }
      });
    },
    // 重置组件的自己的内容和状态
    reset() {
      Gmap.clearMarker();
    },
    setFitView() {
      if (this.actualLineShow && this.planLineShow) {
        Gmap.map.setFitView(null, false, this.mapOffset);
      } else {
        Gmap.init('mapWhole', this.data, this);
      }
    },
    handleClose() {
      this.detailVisible = false;
    },
    handleActualLineShow() {
      this.actualLineShow = !this.actualLineShow;
      Gmap.init('mapWhole', this.data, this);
    },
    handlePlanLineShow() {
      this.planLineShow = !this.planLineShow;
      Gmap.init('mapWhole', this.data, this);
    },
    logsCardShowDetailClick(p) {
      this.detailVisible = true;
      this.activeNodeIndex = p.node_index;
    },
    getTracksAndNodes(source = '-1') {
      const param = {
        task_id: this.task_id,
      };
      if (source && source === '1') {
        param.source = 'sffalcon';
      }
      if (source && source === '0') {
        param.source = 'amap';
      }
      Axios.all([fetchDrivingTracks(param), fetchRouteNodes(param)])
        .then(Axios.spread((res1, res2) => {
          const data = { track: '', nodes: '' };
          if (res1.errno === 0) {
            data.track = res1.result;
          }
          if (res2.errno === 0) {
            data.nodes = res2.result;
          }
          this.data = data;
          console.log('司机实际路线&计划路线', data);
          Gmap.init('mapWhole', this.data, this);
          setTimeout(() => {
            Gmap.map.setFitView(null, false, this.mapOffset);
          }, 1500);
        }));
    },
    calMapHeight() {
      const clienth = document.body.clientHeight;
      const headerh = document.getElementById('task-detail-header').offsetHeight;
      // eslint-disable-next-line radix
      const resth = parseInt(clienth) - parseInt(headerh);
      const mapContainer = document.getElementById('mapWhole');
      mapContainer.style.height = `${resth}px`;
      mapContainer.style.width = '100vw';

      // 判断手机
      const clintw = document.body.clientWidth;
      console.log(clintw);
      const clientRate = clienth / clintw;
      console.log(clientRate);
      if (clientRate < 1) {
        this.mapOffset = [0, 0, 0, 0];
      } else {
        this.mapOffset = [0, 250, 0, 0];
      }
    },
  },
  watch: {
    $route(to) {
      if (to.query && to.query.sffalcon) {
        this.getTracksAndNodes('1');
      } else if (to.query && to.query.amap) {
        this.getTracksAndNodes('0');
      } else {
        this.getTracksAndNodes();
      }
    },
  },
  mounted() {
    this.calMapHeight();
    this.getTracksAndNodes();
    this.getTaskState();
  },
};
</script>
<style lang="less">
.mapWrap{
  position: relative;
  @media screen and (max-width: 700px) {
    .logs-card {
      position: absolute;
      left: 0;
      bottom: 10px;
    }
  }
  @media screen and (min-width: 700px) {
    .logs-card {
      position: absolute;
      right: 10px;
      top: 200px;
    }
  }
  .map-tools{
    position: absolute;
    left: 10px;
    top: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .reset-icon{
      z-index: 500;
      width: 50px;
      height: 50px;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-pack: center;
      justify-content: center;
      background: #fff;
      border: 1px solid #ccc;
      box-shadow: 1px 1px 10px 0 #ccc;
      border-radius: 50%;
      cursor: pointer;
      margin-bottom: 20px;
    }
    .line-tag {
      padding: 5px;
      margin-bottom: 10px;
      color: #fff;
      border-radius: 5px;
      font-size: 12px;
    }
    .actual-line-tag {
      background-color: #409EFF;
    }
    .schedule-line-tag {
      background-color: #67C23A;
    }
    .line-tag-disactive {
      background-color: #ccc;
    }
  }
}

// 头
.has-no-order {
  box-sizing: border-box;
  padding: 40px 0 0 32px;
  width:100%;
  height:200px;
  background:linear-gradient(180deg,rgba(39,116,255,1) 0%,rgba(0,90,255,0.8) 100%);
}
.has-no-order-fl {
  display: flex;
  align-items: center;
}
.has-no-order-fl img {
  width: 32px;
  height: 32px;
  margin-right: 4px;
}
.has-no-order span {
  font-size:28px;
  font-weight:600;
  color:rgba(255,255,255,1);
}
.has-no-order-sl {
  margin-top: 8px;
  font-size: 48px;
  font-weight:600;
  color:rgba(255,255,255,1);
}
.amap-marker-label{
  border: none;
  padding: 0;
  background-color: transparent;
}
.current-info{
  background-color: #1874CD;
  border: none;
  padding: 5px;
  color: #fff;
}
#refreshBtn{
  display: inline-block;
  border-radius: 20px;
  background-color: #fff;
  color: #232323;
  font-size: 12px;
  text-align: center;
  margin-left: 10px;
  border: none;
}
.card-line-content{
  width:inherit;
  display:block;
  white-space:normal;
}
</style>
